import "./style.scss";
import {
  AccessebilityIcon,
  AnchorIcon,
  CalendarIconSvg,
  CardsIcon,
  CheersIcon,
  CordeliaLogoSvg,
  CutleryIcon,
  DiscoBallIcon,
  GuitarIcon,
  MaskIcon,
  MoonIconSvg,
  OneWayTripIconSvg,
  RoomIcon,
  RoundTripIconSvg,
  SanitizerIcon,
  ShipIconSvg,
  SwimmingIcon,
  SwimmingPoolStairsIcon,
  TrolleyIcon,
} from "../../assets/svg";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPublicItineraryDetails } from "../../api/itinerary.api";
import SnackbarContext from "../../context/snackbar.context";
import TermsSection from "../../components/PublicPageSections/Terms";

const PublicDetailPage = () => {
  const snackbarCtx = useContext(SnackbarContext);

  const params = useParams();
  const { itineraryId } = params;

  const [data, setData] = useState<any>({});

  useEffect(() => {
    const fetchData = async () => {
      if (itineraryId) {
        const data = await getPublicItineraryDetails(itineraryId);
        if (data?.status === 200) {
          const { result } = data;
          setData({
            itineraryDetails: result?.details,
            portSequence: result?.port_seq,
            routes: result?.route,
            rooms: result?.rooms,
            cancellationTerms: result?.cancellationPolicies?.[0]?.terms,
            cancellationTableData: result?.cancellationItems,
            rescheduleTerms: result?.reschedulePolicies?.[0]?.terms,
            rescheduleTableData: result?.rescheduleItems
          });
        } else {
          snackbarCtx.toggleSnackbar({
            message: "Something went wrong !",
            type: "FAILURE",
            visible: true,
          });
        }
      }
    };

    fetchData();
  }, [itineraryId]);

  const handleTripType = (tripType: string) => {
    return tripType?.includes("one") ? "One Way Trip" : "Round Trip";
  };

  return (
    <div className="flex justify-center w-full itinerary-details-page-wrapper">
      <div className="max-w-[1200px] w-full flex flex-col">
        <div className="flex justify-between items-center px-4 py-2 nav-bar-wrapper">
          <span className="uppercase">Itinerary Details</span>
          <CordeliaLogoSvg />
        </div>
        <div className="flex flex-col gap-3 mt-12 mx-4 itinerary-info-wrapper">
          <span className="itinerary-info-route">{data?.itineraryDetails?.route}</span>
          <div className="itinerary-info-details-wrapper">
            <span className="flex items-center gap-2 itinerary-info-details">
              <CalendarIconSvg width={20} height={18} fill="#AE4183" />
              {new Date(data?.itineraryDetails?.start_time).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}{" "}
              -{" "}
              {new Date(data?.itineraryDetails?.end_time).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </span>
            <span className="flex items-center gap-2 itinerary-info-details">
              {data?.itineraryDetails?.trip_type?.includes("one") ? (
                <OneWayTripIconSvg width={18} height={18} fill="#AE4183" />
              ) : (
                <RoundTripIconSvg width={18} height={18} />
              )}
              <span>{handleTripType(data?.itineraryDetails?.trip_type)}</span>
            </span>
            <span className="flex items-center gap-2 itinerary-info-details">
              <MoonIconSvg width={17} height={17} fill="#AE4183" />
              {data?.itineraryDetails?.night_count} Nights
            </span>
            <span className="flex items-center gap-2 itinerary-info-details capitalize">
              <ShipIconSvg width={20} height={18} fill="#AE4183" />
              {data?.itineraryDetails?.ship_name?.toLowerCase()}
            </span>
          </div>
        </div>
        {/* <div className="mx-4 mt-12 cruise-overview-wrapper" style={{backgroundImage: `url(https://images.cordeliacruises.com${data?.routes?.cruiseImgUrl})`}}> */}
        <div className="mx-4 mt-12 cruise-overview-wrapper">
          <p className="font-bold text-white">Cruise Overview</p>
          <p className="font-medium text-white">
            Embark on an extraordinary expedition to {data?.portSequence?.[data?.portSequence?.length - 1]?.name} from{" "}
            {data?.portSequence?.[0]?.name} aboard the opulent Oceanic Odyssey Cruise and craft countless cherished
            moments with your companions. Immerse yourself in the breathtaking vistas of the ocean and captivating
            landscapes while traversing the azure Arabian Sea waters. Experience the tranquility of cruising for{" "}
            {data?.itineraryDetails?.night_count} nights within the impeccably appointed cabins of the cruise.
          </p>
        </div>
        <div className="flex flex-col gap-4 mt-12 mx-4 itinerary-inclusions-wrapper">
          <span className="itinerary-inclusions-heading">Inclusions</span>
          <div className="grid grid-cols-2 gap-x-1 gap-y-6 itinerary-inclusions-lists">
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <CutleryIcon />
              <span>Dining Included</span>
            </div>
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <SwimmingIcon />
              <span>Swimming pool & Fitness Access</span>
            </div>
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <RoomIcon />
              <span>Accommodation Available</span>
            </div>
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <AccessebilityIcon />
              <span>Accessible Rooms Available</span>
            </div>
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <CheersIcon />
              <span>Alcohol Package Included</span>
            </div>
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <SanitizerIcon />
              <span>Sanitized Rooms</span>
            </div>
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <MaskIcon />
              <span>Entertainment Access</span>
            </div>
            {/* <div className="flex items-center gap-2 itinerary-inclusions-list">
              <CardsIcon />
              <span>Casino</span>
            </div> */}
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <GuitarIcon />
              <span>Live Band Performance</span>
            </div>
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <SwimmingPoolStairsIcon />
              <span>Party under the start at pool deck</span>
            </div>
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <DiscoBallIcon />
              <span>Disco Night in dome</span>
            </div>
            <div className="flex items-center gap-2 itinerary-inclusions-list">
              <TrolleyIcon />
              <span>Travel Insurance</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4 mt-16 day-details-wrapper">
          {data?.routes?.days?.map((dayInfo: any, index: number) => {
            return (
              <>
                <div className={`flex ${index % 2 ? "flex-row-reverse" : ""} justify-between items-center p-10 day-detail`}>
                  <div className="flex flex-col gap-4 max-w-sm">
                    <span className="text-[#F16F5B] text-[32px] font-bold">Day {`${index + 1}`.padStart(2, '0')}</span>
                    <span className="text-white text-[32px] font-bold uppercase">{dayInfo?.title}</span>
                    {(!!data?.portSequence?.[index]?.departure_time || !!data?.portSequence?.[index]?.arrival_time) && (
                      <span className="bg-[#01B0F3] text-white text-[22px] font-semibold px-4 py-3 rounded w-fit">
                        {index === 0 ? "DEPART" : "ARRIVE"}:{" "}
                        {new Date(
                          index === 0
                            ? data?.portSequence?.[index]?.departure_time
                            : data?.portSequence?.[index]?.arrival_time
                        )
                          .toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                          .toString()}
                        {", "}
                        {new Date(
                          index === 0
                            ? data?.portSequence?.[index]?.departure_time
                            : data?.portSequence?.[index]?.arrival_time
                        ).toLocaleTimeString("en-US", {
                          hour: "numeric",
                          minute: "numeric",
                          hour12: true,
                        })}
                      </span>
                    )}
                    <span className="text-white leading-[45px] text-[22px] font-normal">{dayInfo?.description}</span>
                  </div>
                  <img
                    className="w-1/2 h-[380px] rounded-xl object-cover"
                    src={`https://images.cordeliacruises.com${dayInfo?.image_url}`}
                    alt="cruise-image"
                  />
                </div>
                {!!data?.portSequence?.[index]?.shore_exursions?.length && <div className="flex flex-col gap-4 px-10 pb-10 excursion-details-wrapper">
                  <span className="text-white text-[28px] font-bold excursion-details-header">
                    Shore Excursion Activities: {data?.portSequence?.[index]?.name}
                  </span>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 excursion-cards-wrapper">
                    {data?.portSequence?.[index]?.shore_exursions?.map((item: any) => {
                      return (
                        <div className="flex flex-col excursion-card-wrapper">
                          <img src={item?.images?.[0]} className="rounded-t-md" alt="excursion-image" />
                          <div className="flex-grow flex flex-col w-full p-3 bg-white/10 rounded-b-md excursion-card-details-wrapper">
                            <div className="flex justify-between items-center gap-1 flex-wrap">
                              <span className="text-white text-[18px] font-medium capitalize">
                                {item?.title?.toLowerCase()}
                              </span>
                              <div className="flex items-center gap-1">
                                <AnchorIcon />
                                <span className="text-white text-[18px] font-medium">
                                  {item?.hours} Hrs {+item?.minutes ? item?.minutes + " Mins" : ""}
                                </span>
                              </div>
                            </div>
                            <span className="text-white text-[17px] font-extralight my-4 whitespace-pre-line leading-8">
                              {item?.description?.replace(/(?:\\[rn])+/g, "")}
                            </span>
                            <div className="flex justify-between items-center mt-auto">
                              {!!item?.adult_price && (
                                <span className="text-[16px] font-medium text-[#F16F5B]">
                                  ₹{item?.adult_price}/Adult
                                </span>
                              )}
                              {!!item?.child_price && (
                                <span className="text-[16px] font-medium text-[#F16F5B]">
                                  ₹{item?.child_price}/Children
                                </span>
                              )}
                              {!!item?.infant_price && (
                                <span className="text-[16px] font-medium text-[#F16F5B]">
                                  ₹{item?.infant_price}/Infants
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>}
              </>
            );
          })}
        </div>
        <div className="flex flex-col gap-8 p-10 cruise-activities-wrapper">
          <span className="text-white text-[32px] font-bold">Activities to enjoy in Cruise</span>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 grid-cols-1 gap-4">
            <div className="flex flex-col">
              <img
                src="https://images.cordeliacruises.com/cordelia_v2/public/images/swimming-pool-magazine.webp"
                className="w-full"
              />
              <div className="flex-grow bg-white/10 text-center rounded-b-xl py-4">
                <p className="text-white text-2xl">Swimming Pool</p>
              </div>
            </div>
            <div className="flex flex-col">
              <img
                src="https://images.cordeliacruises.com/cordelia_v2/public/images/rock-climb-magazine.webp"
                className="w-full"
              />
              <div className="flex-grow bg-white/10 text-center rounded-b-xl py-4">
                <p className="text-white text-2xl">Rock Climbing</p>
              </div>
            </div>
            <div className="flex flex-col">
              <img
                src="https://images.cordeliacruises.com/cordelia_v2/public/images/arcade-games-magazine.webp"
                className="w-full"
              />
              <div className="flex-grow bg-white/10 text-center rounded-b-xl py-4">
                <p className="text-white text-2xl">Arcade Games</p>
              </div>
            </div>
            <div className="flex flex-col">
              <img
                src="https://images.cordeliacruises.com/cordelia_v2/public/images/disco-lights-magazine.webp"
                className="w-full"
              />
              <div className="flex-grow bg-white/10 text-center rounded-b-xl py-4">
                <p className="text-white text-2xl">Disco Nights</p>
              </div>
            </div>
            {/* <div className="flex flex-col">
              <img
                src="https://images.cordeliacruises.com/cordelia_v2/public/images/casino-magazine.webp"
                className="w-full"
              />
              <div className="flex-grow bg-white/10 text-center rounded-b-xl py-4">
                <p className="text-white text-2xl">Casino</p>
              </div>
            </div> */}
          </div>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 grid-cols-1 gap-4">
            <div className="flex flex-col">
              <img
                src="https://images.cordeliacruises.com/cordelia_v2/public/images/gym-magazine.webp"
                className="w-full"
              />
              <div className="flex-grow bg-white/10 text-center rounded-b-xl py-4">
                <p className="text-white text-2xl">Gym &#x26; Fitness</p>
              </div>
            </div>
            <div className="flex flex-col">
              <img
                src="https://images.cordeliacruises.com/cordelia_v2/public/images/lunch-magazine.webp"
                className="w-full"
              />
              <div className="flex-grow bg-white/10 text-center rounded-b-xl py-4">
                <p className="text-white text-2xl">Lunch &#x26; Dinner</p>
              </div>
            </div>
            <div className="flex flex-col">
              <img
                src="https://images.cordeliacruises.com/cordelia_v2/public/images/shopping-magazine.webp"
                className="w-full"
              />
              <div className="flex-grow bg-white/10 text-center rounded-b-xl py-4">
                <p className="text-white text-2xl">Shopping</p>
              </div>
            </div>
          </div>
        </div>
        <div className="snorkeling-girl-wrapper">
          <img
            className="w-full pt-24"
            src="https://images.cordeliacruises.com/cordelia_v2/public/images/lakshadweep-magazine-image.webp"
            alt="girl-snorkeling"
          />
        </div>
        <div className="flex items-center justify-around flex-wrap gap-4 p-10 min-h-[180px] external-links-wrapper">
          <a
            href="https://images.cordeliacruises.com/cordelia_v2/public/pdf/cordelia-brochure'25-new.pdf"
            className="text-white text-2xl"
            target="_blank"
          >
            Brochure
          </a>
          <a
            href="http://images.cordeliacruises.com/cordelia_v2/public/pdf/empress-inclusion-exclusion-new-march-2025.pdf"
            className="text-white text-2xl"
            target="_blank"
          >
            Inclusions & Exclusions
          </a>
          <a href="https://www.youtube.com/watch?v=Upt7MQLzWJ8" className="text-white text-2xl" target="_blank">
            Video
          </a>
          <a
            href="https://images.cordeliacruises.com/static/Cordelia%20-%20Add%20On%20Services%20Flyers-compressed.pdf"
            className="text-white text-2xl"
            target="_blank"
          >
            Add on
          </a>
          {/* <a
            href="https://images.cordeliacruises.com/pdf/Subcat_Grid.pdf"
            className="text-white text-2xl"
            target="_blank"
          >
            Compare now
          </a> */}
        </div>
        <TermsSection cancellationTerms={data?.cancellationTerms} cancellationTableData={data?.cancellationTableData} rescheduleTerms={data?.rescheduleTerms} rescheduleTableData={data?.rescheduleTableData}/>
      </div>
    </div>
  );
};

export default PublicDetailPage;
